RivalIQ.module('export.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ExportLimitModal = Marionette.ItemView.extend({

        template: '#exportLimitModalTemplate',

        ui: {
            contactUsBtn: '.x-contact-us'
        },

        events: {
            'click @ui.contactUsBtn': 'onContactUsClick'
        },

        templateHelpers: function () {
            return {
                trialReportLimit: RivalIQ.state.account.get('trialReportLimit')
            };
        },

        onContactUsClick: function () {

            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: 'over trial export limit'
                })
            }));
        }

    });

});
